import { useState } from 'react';

const TIME_RANGES = [
  { id: '15m', label: 'Last 15 minutes', ms: 15 * 60_000 },
  { id: '1h', label: 'Last hour', ms: 3600_000 },
  { id: '24h', label: 'Last 24 hours', ms: 86_400_000 },
  { id: '7d', label: 'Last 7 days', ms: 7 * 86_400_000 },
  { id: 'all', label: 'Any time', ms: 0 },
  { id: 'custom', label: 'Between…', ms: 0 },
];

/** datetime-local value (local time) ↔ ISO. */
export const toLocalInput = (iso: string | null | undefined) => {
  if (!iso) return '';
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
};

interface TimeRangeValue { range: string; from: string; to: string }

/** Time range state; `window()` is recomputed on every call so "last hour" keeps moving. */
export function useTimeRange(initial = 'all') {
  const [value, setValue] = useState<TimeRangeValue>({ range: initial, from: '', to: '' });
  const window = () => {
    if (value.range === 'custom') return { from: value.from, to: value.to };
    const r = TIME_RANGES.find((x) => x.id === value.range);
    return r?.ms ? { from: new Date(Date.now() - r.ms).toISOString(), to: '' } : { from: '', to: '' };
  };
  return { value, setValue, window, key: `${value.range}|${value.from}|${value.to}` };
}

export function TimeRange({ value, onChange }: { value: TimeRangeValue; onChange: (v: TimeRangeValue) => void }) {
  return (
    <>
      <select className="select" style={{ width: 170 }} value={value.range} aria-label="Time"
        onChange={(e) => onChange({ range: e.target.value, from: e.target.value === 'custom' ? value.from || new Date(Date.now() - 3600_000).toISOString() : '', to: '' })}>
        {TIME_RANGES.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
      </select>
      {value.range === 'custom' && (
        <>
          <input className="input" style={{ width: 200 }} type="datetime-local" aria-label="From" value={toLocalInput(value.from)}
            onChange={(e) => onChange({ ...value, from: e.target.value ? new Date(e.target.value).toISOString() : '' })} />
          <span className="faint">to</span>
          <input className="input" style={{ width: 200 }} type="datetime-local" aria-label="To" value={toLocalInput(value.to)}
            onChange={(e) => onChange({ ...value, to: e.target.value ? new Date(e.target.value).toISOString() : '' })} />
        </>
      )}
    </>
  );
}
